var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgProspect = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none",
  viewBox: "0 0 16 16",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "m2.406 1.097-.71.71.355.352.707.707.351.356.711-.711-.355-.352-.707-.707-.352-.355Zm11.188 0-.352.355-1.058 1.059.707.71.351-.355 1.059-1.058-.707-.711ZM8 1.9c-2.203 0-4 1.797-4 4 0 1.383.605 2.18 1.094 2.86.492.676.906 1.25.906 2.64v1a1.5 1.5 0 0 0 1.008 1.407A.714.714 0 0 0 7 13.9c0 .551.45 1 1 1s1-.449 1-1c0-.03 0-.062-.004-.093A1.5 1.5 0 0 0 10 12.4v-1c0-1.39.414-1.964.906-2.64C11.395 8.08 12 7.284 12 5.9c0-2.203-1.797-4-4-4Zm0 1c1.664 0 3 1.336 3 3 0 1.118-.395 1.57-.906 2.266-.442.613-.88 1.477-1 2.734H6.906c-.12-1.257-.558-2.12-1-2.734C5.395 7.472 5 7.019 5 5.901c0-1.664 1.336-3 3-3Zm-7 3v1h2v-1H1Zm12 0v1h2v-1h-2ZM3.11 9.58l-.352.356-.707.707-.356.351.711.707 1.059-1.058.355-.352-.71-.711Zm9.78 0-.706.711 1.41 1.41.707-.707-1.059-1.058-.351-.356ZM7 11.901h2v.5c0 .282-.219.5-.5.5h-1a.494.494 0 0 1-.5-.5v-.5Z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgProspect);
export default ForwardRef;